import { FC } from 'react';
import { AllieItemStyled, BubbleStyled, QuickButtonContainer } from './QuickButton.styles';
import { AllieText } from '../../../../components';

interface QuickButtonProps {
  title: string;
  subtitle?: string;
  isSelected?: boolean;
  type?: 'default' | 'full';
  onClick?: () => void;
}

export const QuickButton: FC<QuickButtonProps> = ({
  onClick,
  title,
  subtitle,
  isSelected,
  type,
}) => {
  return (
    <AllieItemStyled button onclick={onClick}>
      <BubbleStyled isSelected={isSelected} type={type}>
        <QuickButtonContainer>
          <AllieText color={isSelected ? 'white' : 'neutral-70'} type="body1" weight={500}>
            {title}
          </AllieText>
          {subtitle && (
            <AllieText color={isSelected ? 'white' : 'neutral-70'} type="body3">
              {subtitle}
            </AllieText>
          )}
        </QuickButtonContainer>
      </BubbleStyled>
    </AllieItemStyled>
  );
};
